/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import React from "react";
import { createRoot } from "react-dom/client";
import store, { persistor } from "./app/store/store";
import App from "./App";
import "./index.scss"; // Standard version
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";
/**
 * Base URL of the website.
 *
 * @see https://vitejs.dev/guide/build.html#public-base-path
 */
const BASE_URL = import.meta.env.BASE_URL;

const root = createRoot(document.getElementById("root"));
root.render(
  <App store={store} persistor={persistor} basename={BASE_URL} />
);
